import { z } from "zod";

import { ACTIVITY_PERIODS } from "./ACTIVITY_PERIODS";

// Search params профиля: `/profile?activity=30d` — период «Активности». Нет параметра или
// неверное значение — период по умолчанию.
export const profileSearchSchema = z.object({
  activity: z.enum(ACTIVITY_PERIODS).optional().catch(undefined),
});

export type ProfileSearch = z.infer<typeof profileSearchSchema>;
